const ZIP = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            fill="currentColor"
            d="M19.4 2.01a2 2 0 0 1 1.796 1.989v16.003l-.01.204A2 2 0 0 1 19.4 21.99l-.204.01H6.209l-.204-.01a2 2 0 0 1-1.785-1.785l-.01-.204v-2.078H3.033v-7.01h1.175V4a2 2 0 0 1 1.796-1.99L6.21 2h12.987l.204.01ZM6.21 3.498a.5.5 0 0 0-.5.5v6.916h10.899v7.01h-10.9V20a.5.5 0 0 0 .5.5h12.987a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5H6.209Zm.976 10.048h1.136L7.158 15.38v.44h1.891v-.528H7.862l1.164-1.835v-.436h-1.84v.527Zm2.229 2.273h.551v-2.8h-.551v2.8Zm1.07 0h.552v-.92h.492c.54 0 .956-.417.956-.94a.938.938 0 0 0-.956-.94h-1.044v2.8Zm1.044-2.284c.236 0 .407.18.407.424 0 .24-.172.423-.407.423h-.492v-.847h.492Z"
        />
    </svg>
);

export default ZIP;
